import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import styles from '../styles/WinMessage.module.css';
import { Button, DialogContent, DialogContentText } from '@material-ui/core';
import { LinkedList } from 'prelude-ts';
import { RuleApplication } from '../Rule';
import ProofTree from './ProofTree';

const levelWinMsg = 'Level Complete!';
const gameWinMsg = 'You beat the game!';

interface Props {
  open: boolean;
  gameOver: boolean;
  currentLevel: number;
  gotoLevel(levelNumber: number): void;
  proof: LinkedList<RuleApplication>;
}

class WinMessage extends Component<Props> {
  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        aria-labelledby="win-message-title"
        aria-describedby="win-message-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle id="win-message-title">
          {this.props.gameOver ? gameWinMsg : levelWinMsg}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>Your Proof:</DialogContentText>
          <ProofTree rules={this.props.proof} printDepth={-1} />
        </DialogContent>
        <DialogActions>
          <Button
            tabIndex={2}
            onClick={() => {
              if (this.props.open) {
                this.props.gotoLevel(this.props.currentLevel);
              }
            }}
          >
            Restart Level
          </Button>

          <Button
            className={this.props.gameOver ? styles.hidden : ''}
            tabIndex={1}
            onClick={() => {
              if (this.props.open) {
                this.props.gotoLevel(this.props.currentLevel + 1);
              }
            }}
            autoFocus
          >
            Next Level
          </Button>

          <Button
            className={this.props.gameOver ? '' : styles.hidden}
            tabIndex={1}
            onClick={() => this.props.gotoLevel(0)}
            autoFocus
          >
            Restart Game
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default WinMessage;
